module.exports = "<v-container> <v-layout row wrap> <v-flex xs12> <v-select placeholder=\"Wybierz nazwę grupy\" label=\"Wybierz nazwę grupy\" v-bind:items=waterUsageRecipients item-text=name v-bind:return-object=true no-data-text=\"Brak grupy\" v-model=waterUsageRecipient v-on:input=\"updateValue('waterUsageRecipient', $event)\"></v-select> </v-flex> </v-layout> </v-container> ";


//////////////////
// WEBPACK FOOTER
// ./src/components/viewer/edition/template/templateDialogLoadRecipients.html
// module id = 2179
// module chunks = 0